// remove this once the new API's are built
export const signinUser = (
  emailOrLogin: string,
  password: string,
  rememberMe: "0" | "1"
): void => {
  if (process.env.NODE_ENV === "development") return;

  const form = document.createElement("form");
  form.setAttribute("method", "post");
  form.setAttribute("action", "/users/session");
  form.style.display = "none";

  const emailEl = document.createElement("input");
  emailEl.setAttribute("name", "user[email_or_login]");
  emailEl.setAttribute("value", emailOrLogin);

  const passwordEl = document.createElement("input");
  passwordEl.setAttribute("name", "user[password]");
  passwordEl.setAttribute("value", password);

  const rememberMeEl = document.createElement("input");
  rememberMeEl.setAttribute("name", "user[remember_me]");
  rememberMeEl.setAttribute("value", rememberMe);

  form.appendChild(emailEl);
  form.appendChild(passwordEl);
  form.appendChild(rememberMeEl);

  document.body.appendChild(form);
  form.submit();
};
